export function applyCepResponseToForm($j, $form, dados) {
  const $endereco = $form.find("#params_endereco");
  const $cep = $form.find("#params_cep");
  const $bairro = $form.find("#params_bairro");
  const $compl = $form.find("#params_complemento");

  if ($endereco.length && dados.street !== undefined) {
    $endereco.val(dados.street).trigger("input").trigger("change");
  }
  if ($cep.length && dados.zipcode !== undefined) {
    $cep.val(dados.zipcode).trigger("input").trigger("change");
  }
  if ($bairro.length && dados.neighborhood !== undefined) {
    $bairro.val(dados.neighborhood).trigger("input").trigger("change");
  }
  if ($compl.length && (dados.complement !== undefined || dados.complemento !== undefined)) {
    $compl.val(dados.complement || dados.complemento).trigger("input").trigger("change");
  }

  // município: tenta os possíveis ids (porque isso varia conforme helper)
  if (dados.city !== undefined) {
    const $muni =
      $form.find("#autocomplete_admissao_municipio").first().length ? $form.find("#autocomplete_admissao_municipio").first() :
        $form.find("#admissao_municipio").first().length ? $form.find("#admissao_municipio").first() :
          $form.find("#params_municipio").first().length ? $form.find("#params_municipio").first() :
            $form.find('input[name*="municipio"]').first();

    if ($muni && $muni.length) {
      $muni.val(dados.city).trigger("input").trigger("change");
    }
  }
}
